import { render, staticRenderFns } from "./CollapsableCategory.component.vue?vue&type=template&id=46f2995d&"
import script from "./CollapsableCategory.component.vue?vue&type=script&lang=js&"
export * from "./CollapsableCategory.component.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableCategory.component.vue?vue&type=style&index=0&id=46f2995d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports